function showMobileSidebar() {
  document.getElementById("navigation-mobile-sidebar-wrapper").classList.add("navigation-mobile-sidebar-out");
}
function hideMobileSidebar() {
  document.getElementById("navigation-mobile-sidebar-wrapper").classList.remove("navigation-mobile-sidebar-out");
}
function hideMobileTier(id) {
  const mobileTierElement = document.getElementById(id)
  if (mobileTierElement) {
    mobileTierElement.classList.add("hidden");
  }
}
function footerDropdown(e) {
  e.target.nextElementSibling.classList.toggle("footer-dropdown-open"), e.target.classList.toggle("footer-dropdown-open");
}
function toggleMobileNavDropdown(e) {
  e.target.nextElementSibling.classList.toggle("hidden");e.target.classList.toggle("mobile-nav-footer-dropdown-open");
}
function showMobileFilters() {
  document.getElementById("filters-mobile").classList.add("filters-mobile-open");
}
function hideMobileFilters() {
  document.getElementById("filters-mobile").classList.remove("filters-mobile-open");
}
function filterGroupDropdown(e) {
  e.target.nextElementSibling.classList.toggle("filter-group-open"), e.target.classList.toggle("filter-group-open");
}
function showMoreImages(e) {
  e.target.remove(), (document.getElementById("more-images").style.display = "block");
}
function scrollToProductForm() {
  var e = document.getElementById("product-form"),
    t = document.getElementById("mobile-header").offsetHeight,
    s = document.getElementById("product-header-mobile").offsetHeight,
    d = e.offsetTop - (t + s);
  window.scrollTo({ top: d, behavior: "smooth" });
}
function scrollToCartForm() {
  var e = document.getElementById("cart-form-wrapper"),
    t = document.getElementById("mobile-header").offsetHeight,
    d = e.offsetTop - t;
  window.scrollTo({ top: d, behavior: "smooth" });
}
function showSizeGuide() {
  const sizeGuideModal = document.getElementById("size-guide-modal");
  if (!sizeGuideModal) {
    return;
  }
  sizeGuideModal.classList.remove("hidden");
}
function hideSizeGuide() {
  const sizeGuideModal = document.getElementById("size-guide-modal");
  if (!sizeGuideModal) {
    return;
  }
  sizeGuideModal.classList.add("hidden");
}
function setCookiesNotificationCookie(domain) {
  var domain = domain;
  var cookieExpires = document.getElementById("cookies-notification-banner").getAttribute('data-cookie-expires') || 30;
  var maxAge = 90 * 24 * 60 * Number(cookieExpires);
  var cookiesNotificationCookie = 'cookiesNotification=true;max-age=' + maxAge + ';domain=.' + domain + ';path=/';
  document.cookie = cookiesNotificationCookie;
}
function hideCookiesNotificationBanner(domain) {
  document.getElementById("cookies-notification-banner").classList.add("hidden");
  setCookiesNotificationCookie(domain);
}
function setLocalizationNotificationCookie(domain) {
  var domain = domain;
  var cookieExpires = document.getElementById("localization-notification-banner").getAttribute('data-cookie-expires') || 30;
  var maxAge = 90 * 24 * 60 * Number(cookieExpires);
  var localizationCookie = 'localizationNotification=true;max-age=' + maxAge + ';domain=.' + domain + ';path=/';
  document.cookie = localizationCookie;
}
function hideLocalizationNotification() {
  document.getElementById("localization-notification-banner").classList.add("hidden");
}
function setNewsletterModalCookie(domain) {
  var domain = domain;
  var cookieExpires = document.getElementById("newsletter-modal").getAttribute('data-cookie-expires') || 30;
  var maxAge = 90 * 24 * 60 * Number(cookieExpires);
  var newsletterModalCookie = 'newsletterModal=true;max-age=' + maxAge + ';domain=.' + domain + ';path=/';
  document.cookie = newsletterModalCookie;
}
function showNewsletterModal(domain) {
  document.getElementById("newsletter-modal").classList.remove("hidden");
  setNewsletterModalCookie(domain);
}
function showKlaviyoBisModal(formId) {
  if (!formId) return;
  if (window.KlaviyoOnSite && window.KlaviyoOnSite.BIS) {
    window.KlaviyoOnSite.BIS.openModal();
  } else if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
    window.klaviyo.openForm(formId); 
  } else {
    showNewsletterModal(domain);
  }
}
function hideNewsletterModal() {
  document.getElementById("newsletter-modal").classList.add("hidden");
}
function showStorefrontPasswordForm() {
  document.getElementById("storefront-password-modal").classList.remove("hidden");
}
function hideStorefrontPasswordForm() {
  document.getElementById("storefront-password-modal").classList.add("hidden");
}
function customerResetPassword() {
  var e = document.getElementById("customer-reset-password-form");
  e.classList.contains("hidden") ? e.classList.remove("hidden") : e.classList.add("hidden");
}
function customerAddAddress(e) {
  var t = document.getElementById("customer-new-address");
  e.target.remove(), t.classList.remove("hidden");
}
function customerEditAddress(e, t) {
  var s = document.getElementById(t),
    d = e.target.getAttribute("data-edit-text"),
    o = e.target.getAttribute("data-cancel-edit-text");
  s.classList.contains("hidden") ? (s.classList.remove("hidden"), (e.target.innerHTML = o)) : (s.classList.add("hidden"), (e.target.innerHTML = d));
}
function showLoadingBar() {
  const bar = document.getElementById('loading-bar');
  if (bar) bar.classList.remove('hidden');
}
function submitCartQuantityChange(input) {
  if (input.form) {
    input.form.submit();
  } else {
    console.warn("No associated form found for this input.");
  }
}
function updateQuantity(id, action) {
  let input = document.getElementById(id);
  if (!input) return;
  if (action === 'down') {
    input.stepDown();
  } else {
    input.stepUp();
  }
  setTimeout(() => {
    submitCartQuantityChange(input);
  }, 500);
}